/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/Button';
import Field from 'components/Field';

type Props = {
  title: string,
  subtext?: any,
  renderCollector: Function,
  buttonDisabled: Function,
  onSubmit: Function,
};

type State = {
  submitted: boolean,
};

export default class BirthdateModalSection extends React.Component<Props, State> {
  state: State = {
    submitted: false,
  };

  handleSubmit = () => {
    this.setState({ submitted: true });
    this.props.onSubmit();
  };

  render() {
    return (
      <div className="BirthdateModalSection">
        <BoxHeader title={this.props.title} subtext={this.props.subtext} />
        <BoxBody divided>
          <Field>{this.props.renderCollector()}</Field>
          <Button
            level="primary"
            onClick={this.handleSubmit}
            disabled={this.state.submitted || this.props.buttonDisabled()}>
            Submit
          </Button>
        </BoxBody>
      </div>
    );
  }
}
